import React, {useState} from "react";
import PageTitle from "./include/PageTitle";
import {Link} from "react-router-dom";
import Seo from "../Utils/Seo";
import BookNowModal from "./include/BookNowModal";

const Services = ({title}) => {
    const [bookModal, setBookModal] = useState({open: false, note: ""});
    const openBook = (note) => setBookModal({open: true, note});
    const closeBook = () => setBookModal({open: false, note: ""});

    return (
        <div>
            <Seo
                title="Chiller Van, Freezer Truck and Refrigerated Transport Services UAE"
                description="Explore refrigerated transport services in Dubai, Abu Dhabi, Ajman, Sharjah and across the UAE including chiller vans, freezer trucks, reefer transport and temperature-controlled delivery."
                path="/services"
                keywords="chiller van rental Dubai, freezer truck rental UAE, reefer truck Dubai, temperature controlled transport UAE, refrigerated transport services, refrigerated truck rental UAE, نقل مبرد الإمارات, تأجير شاحنة مبردة دبي, نقل فريزر دبي"
            />

            <PageTitle title={title}/>

            <section className="pt-70 pb-30">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-7 mb-30">
                            <h2 className="ca-section-title theme-black-3 fnw-600">
                                Refrigerated transport services built for UAE cold-chain delivery
                            </h2>
                            <p className="pt-16">
                                Book chiller van rental in Dubai, freezer truck rental in Abu Dhabi, refrigerated truck
                                delivery in Ajman and temperature-controlled transport across Sharjah and the wider
                                UAE for food, pharma, dairy, seafood and catering supply.
                            </p>
                        </div>
                        <div className="col-lg-5 mb-30">
                            <div className="ca-ser-icon-box ca-ser-icon-box-2 cream-bg-3 p-32 br-7">
                                <h3 className="ca-title fnw-700 pb-16">
                                    UAE refrigerated delivery coverage
                                </h3>
                                <p className="mb-0">
                                    We provide chiller vans, freezer trucks and refrigerated vehicles for Dubai, Abu
                                    Dhabi, Ajman, Sharjah, Ras Al Khaimah, Fujairah, Umm Al Quwain and Al Ain, with
                                    the right temperature range for each load.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <div className="ca-iner-servics pt-100 pb-100">
                <div className="container">
                    <div className="row">
                        {/* single service box */}
                        <div className="col-xl-4 col-md-6 mb-30">
                            <div
                                className="ca-ser-icon-box ca-ser-icon-box-2 fix p-relative cream-bg-3 z-index-1 p-32 br-7">
                                <div className="ca-about-icon">
                                    <div className="ca-about-ic ca-ser-ic">
                                        <img src="assets/img/icon/ca-iner-ser1.1.svg" alt=""/>
                                    </div>
                                    <div className="ca-num">
                                        <h4 className="overly-num overly-num2">01</h4>
                                    </div>
                                </div>
                                <div className="ca-service-content ca-service-content-iner">
                                    <h4 className="ca-title fnw-700 pb-16 pt-32">
                                        <Link to="service-single.html">Chiller Van</Link>
                                    </h4>
                                    <p className="pb-24">
                                        A Chiller Van is specially designed to transport temperature-sensitive goods at
                                        a controlled temperature. Ideal for perishable items like dairy, fruits, and
                                        vegetables, it ensures freshness and quality during transit
                                    </p>
                                    <button
                                        type="button"
                                        className="ca-btn-primary-3 theme-bg-3 text-white br-50 text-center py-2 border-0 w-100"
                                        style={{minHeight: "44px", cursor: "pointer"}}
                                        onClick={() => openBook("Chiller van — Dubai & UAE")}
                                    >
                                        Book now
                                    </button>
                                </div>
                            </div>
                        </div>
                        {/* single service box */}
                        <div className="col-xl-4 col-md-6 mb-30">
                            <div
                                className="ca-ser-icon-box ca-ser-icon-box-2 fix p-relative cream-bg-3 z-index-1 p-32 br-7">
                                <div className="ca-about-icon">
                                    <div className="ca-about-ic ca-ser-ic">
                                        <img src="assets/img/icon/ca-iner-ser1.2.svg" alt=""/>
                                    </div>
                                    <div className="ca-num">
                                        <h4 className="overly-num overly-num2">02</h4>
                                    </div>
                                </div>
                                <div className="ca-service-content ca-service-content-iner">
                                    <h4 className="ca-title fnw-700 pb-16 pt-32">
                                        <Link to="service-single.html">Freezer Van</Link>
                                    </h4>
                                    <p className="pb-24">
                                        A Freezer Van provides a cold storage solution for transporting frozen goods.
                                        Equipped with powerful refrigeration systems, it is perfect for delivering
                                        frozen foods, ice cream, and other products that require sub-zero temperatures.
                                    </p>
                                    <button
                                        type="button"
                                        className="ca-btn-primary-3 theme-bg-3 text-white br-50 text-center py-2 border-0 w-100"
                                        style={{minHeight: "44px", cursor: "pointer"}}
                                        onClick={() => openBook("Freezer van — Dubai & UAE")}
                                    >
                                        Book now
                                    </button>
                                </div>
                            </div>
                        </div>
                        {/* single service box */}
                        <div className="col-xl-4 col-md-6 mb-30">
                            <div
                                className="ca-ser-icon-box ca-ser-icon-box-2 fix p-relative cream-bg-3 z-index-1 p-32 br-7">
                                <div className="ca-about-icon">
                                    <div className="ca-about-ic ca-ser-ic">
                                        <img src="assets/img/icon/ca-iner-ser1.3.svg" alt=""/>
                                    </div>
                                    <div className="ca-num">
                                        <h4 className="overly-num overly-num2">03</h4>
                                    </div>
                                </div>
                                <div className="ca-service-content ca-service-content-iner">
                                    <h4 className="ca-title fnw-700 pb-16 pt-32">
                                        <Link to="service-single.html">Chiller Truck</Link>
                                    </h4>
                                    <p className="pb-24">
                                        Chiller Trucks are built for transporting larger shipments of
                                        temperature-sensitive items. With advanced refrigeration technology, they
                                        maintain a consistent cold environment, making them ideal for food distribution
                                        and pharmaceuticals.
                                    </p>
                                    <button
                                        type="button"
                                        className="ca-btn-primary-3 theme-bg-3 text-white br-50 text-center py-2 border-0 w-100"
                                        style={{minHeight: "44px", cursor: "pointer"}}
                                        onClick={() => openBook("Chiller truck — Dubai & UAE")}
                                    >
                                        Book now
                                    </button>
                                </div>
                            </div>
                        </div>
                        {/* single service box */}
                        <div className="col-xl-4 col-md-6 mb-30">
                            <div
                                className="ca-ser-icon-box ca-ser-icon-box-2 fix p-relative cream-bg-3 z-index-1 p-32 br-7">
                                <div className="ca-about-icon">
                                    <div className="ca-about-ic ca-ser-ic">
                                        <img src="assets/img/icon/ca-iner-ser1.4.svg" alt=""/>
                                    </div>
                                    <div className="ca-num">
                                        <h4 className="overly-num overly-num2">04</h4>
                                    </div>
                                </div>
                                <div className="ca-service-content ca-service-content-iner">
                                    <h4 className="ca-title fnw-700 pb-16 pt-32">
                                        <Link to="service-single.html">Freezer Truck</Link>
                                    </h4>
                                    <p className="pb-24">
                                        A Freezer Truck is designed for bulk transportation of frozen items, ensuring
                                        that products remain at optimal freezing temperatures. It’s essential for
                                        businesses needing reliable transport for large quantities of frozen foods.
                                    </p>
                                    <button
                                        type="button"
                                        className="ca-btn-primary-3 theme-bg-3 text-white br-50 text-center py-2 border-0 w-100"
                                        style={{minHeight: "44px", cursor: "pointer"}}
                                        onClick={() => openBook("Freezer truck — Dubai & UAE")}
                                    >
                                        Book now
                                    </button>
                                </div>
                            </div>
                        </div>
                        {/* single service box */}
                        <div className="col-xl-4 col-md-6 mb-30">
                            <div
                                className="ca-ser-icon-box ca-ser-icon-box-2 fix p-relative cream-bg-3 z-index-1 p-32 br-7">
                                <div className="ca-about-icon">
                                    <div className="ca-about-ic ca-ser-ic">
                                        <img src="assets/img/icon/ca-iner-ser1.5.svg" alt=""/>
                                    </div>
                                    <div className="ca-num">
                                        <h4 className="overly-num overly-num2">05</h4>
                                    </div>
                                </div>
                                <div className="ca-service-content ca-service-content-iner">
                                    <h4 className="ca-title fnw-700 pb-16 pt-32">
                                        <Link to="service-single.html">Cold Transport</Link>
                                    </h4>
                                    <p className="pb-24">
                                        Cold Transport refers to the specialized transport of moving refrigerated items
                                        to ensure their safety and quality. This service is crucial for perishable goods
                                        like food, flowers, and pharmaceuticals, maintaining the cold chain throughout
                                        the journey.
                                    </p>
                                    <button
                                        type="button"
                                        className="ca-btn-primary-3 theme-bg-3 text-white br-50 text-center py-2 border-0 w-100"
                                        style={{minHeight: "44px", cursor: "pointer"}}
                                        onClick={() => openBook("Cold transport — Dubai & UAE")}
                                    >
                                        Book now
                                    </button>
                                </div>
                            </div>
                        </div>

                    </div>

                </div>
            </div>

            <BookNowModal
                open={bookModal.open}
                onClose={closeBook}
                heading="Book now"
                note={bookModal.note || undefined}
            />
        </div>
    );
};

export default Services;
